import { Button, Col, Collapse, Row, Table } from 'antd';
import dayjs from 'dayjs';
import PrintIcon from 'icons/print.svg';
import { localize } from 'mixins/helpers';
import CmsTable from 'mixins/ui/cms-table';
import PrintForm2 from 'mixins/ui/print-form-2';
import React, { useState } from 'react';

const Results = ({ data, printUrl, translations, language, token }) => {
    const [showTables, setShowTables] = useState(Array(data?.taxOrgInfos.length).fill(false));
    const [showDebts, setShowDebts] = useState({});

    const as_of = localize('info-absence-tax-debt-as-of', translations).split('__DATE__');

    const columns = [
        {
            title: as_of[0] + dayjs(new Date()).format('DD.MM.YYYY') + as_of[1],
            width: 150,
            render: () => '№',
        },
        {
            title: localize('info-absence-tax-debt-total-arrear', translations),
            dataIndex: 'totalArrear',
        },
        {
            title: localize('info-absence-tax-debt-total-tax-arrear', translations),
            dataIndex: 'totalTaxArrear',
        },
        {
            title: localize('info-absence-tax-debt-pension-arrears', translations),
            width: 200,
            dataIndex: 'pensionContributionArrear',
        },
        {
            title: localize('info-absence-tax-debt-social-health-arrears', translations),
            width: 200,
            dataIndex: 'socialHealthInsuranceArrear',
        },
        {
            title: localize('info-absence-tax-debt-social-arrears', translations),
            width: 200,
            dataIndex: 'socialContributionArrear',
        },
    ];

    const thirdColumns = [
        {
            title: localize('info-absence-tax-debt-taxpayer-code', translations),
            dataIndex: 'iinBin',
        },
        {
            title: localize('info-absence-tax-debt-taxpayer-name', translations),
            dataIndex: 'nameRu',
        },
        {
            title: localize('info-absence-tax-debt-total-debt', translations),
            dataIndex: 'totalArrear',
        },
    ];

    const fourColumns = [
        {
            title: localize('info-absence-tax-debt-total-tax-arrear', translations),
            dataIndex: 'totalArrear',
        },
        {
            title: localize('info-absence-tax-debt-pension-arrears', translations),
            dataIndex: 'pensionContributionArrear',
        },
        {
            title: localize('info-absence-tax-debt-social-health-arrears', translations),
            dataIndex: 'socialHealthInsuranceArrear',
        },
        {
            title: localize('info-absence-tax-debt-social-arrears', translations),
            dataIndex: 'socialContributionArrear',
        },
    ];

    const fiveColumns = [
        {
            title: localize('info-absence-tax-debt-bcc', translations),
            width: '80px',
            dataIndex: 'bcc',
        },
        {
            title: localize('info-absence-tax-debt-bcc-name', translations),
            width: '150px',
            dataIndex: 'bccNameRu',
        },
        {
            title: localize('info-absence-tax-debt-tax-debt-amount', translations),
            dataIndex: 'taxArrear',
        },
        {
            title: localize('info-absence-tax-debt-penalties-arrears', translations),
            dataIndex: 'poenaArrear',
        },
        {
            title: localize('info-absence-tax-debt-fine-arrears', translations),
            dataIndex: 'fineArrear',
        },
        {
            title: localize('info-absence-tax-debt-interest-arrears', translations),
            dataIndex: 'percentArrear',
        },
        {
            title: localize('info-absence-tax-debt-total-arrear', translations),
            dataIndex: 'totalArrear',
        },
    ];

    const CollapseHeader = (charCode, nameRu, totalArrear) => {
        return (
            <Row
                className="second-table-data mt-3"
                gutter={[16, 10]}
            >
                <Col xs={6}>{localize('info-absence-tax-debt-sra-code', translations)}</Col>
                <Col xs={18}>{charCode}</Col>

                <Col xs={6}>{localize('info-absence-tax-debt-sra-name', translations)}</Col>
                <Col xs={18}>{nameRu}</Col>

                <Col xs={6}> {localize('info-absence-tax-debt-total-debt', translations)}</Col>
                <Col xs={18}>{totalArrear}</Col>

                <Col xs={6}>{as_of[0]}</Col>
                <Col xs={18}>{dayjs(new Date()).format('DD.MM.YYYY') + as_of[1]}</Col>
            </Row>
        );
    };

    return (
        <>
            <CmsTable
                resultCard={data?.iinBin}
                noResNumber
                showNumbers={false}
                dataSource={[data]}
                columns={columns}
                pagination={false}
                showDebt
                type="default"
                style={{ marginBottom: 10 }}
                translations={translations}
            >
                <Col style={{ fontSize: 14 }}>{localize('iin-bin', translations)}</Col>
            </CmsTable>
            {data?.taxOrgInfos.map((taxItem, id) => {
                return (
                    <div
                        style={{
                            border: '1px solid rgb(214, 214, 230)',
                            padding: 20,
                            marginBottom: 20,
                            backgroundColor: '#fafafa',
                        }}
                    >
                        <Collapse.Panel
                            header={CollapseHeader(
                                taxItem.charCode,
                                taxItem.nameRu,
                                taxItem.totalArrear
                            )}
                            key={id}
                            showArrow={false}
                            style={{ marginTop: 20, marginBottom: 20 }}
                        >
                            <Row>
                                <table
                                    style={{
                                        border: '1px solid rgb(214, 214, 230)',
                                    }}
                                >
                                    <tr className="ant-table-row ant-table-row-level-0">
                                        <td
                                            className="ant-table-cell"
                                            style={{ width: '80%', border: '1px solid #f0f0f0' }}
                                        >
                                            {localize(
                                                'info-absence-tax-debt-total-tax-arrear',
                                                translations
                                            )}
                                        </td>
                                        <td
                                            className="ant-table-cell"
                                            style={{ width: '20%', border: '1px solid #f0f0f0' }}
                                        >
                                            {taxItem?.totalTaxArrear}
                                        </td>
                                    </tr>
                                    <tr className="ant-table-row ant-table-row-level-0">
                                        <td
                                            className="ant-table-cell"
                                            style={{ width: '80%', border: '1px solid #f0f0f0' }}
                                        >
                                            {localize(
                                                'info-absence-tax-debt-pension-arrears',
                                                translations
                                            )}
                                        </td>
                                        <td
                                            className="ant-table-cell"
                                            style={{ width: '20%', border: '1px solid #f0f0f0' }}
                                        >
                                            {taxItem?.pensionContributionArrear}
                                        </td>
                                    </tr>
                                    <tr className="ant-table-row ant-table-row-level-0">
                                        <td
                                            className="ant-table-cell"
                                            style={{ width: '80%', border: '1px solid #f0f0f0' }}
                                        >
                                            {localize(
                                                'info-absence-tax-debt-social-health-arrears',
                                                translations
                                            )}
                                        </td>
                                        <td
                                            className="ant-table-cell"
                                            style={{ width: '20%', border: '1px solid #f0f0f0' }}
                                        >
                                            {taxItem?.socialHealthInsuranceArrear}
                                        </td>
                                    </tr>
                                    <tr className="ant-table-row ant-table-row-level-0">
                                        <td
                                            className="ant-table-cell"
                                            style={{ width: '80%', border: '1px solid #f0f0f0' }}
                                        >
                                            {localize(
                                                'absence-tax-debt-social-arrears',
                                                translations
                                            )}
                                        </td>
                                        <td
                                            className="ant-table-cell"
                                            style={{ width: '20%', border: '1px solid #f0f0f0' }}
                                        >
                                            {taxItem?.socialContributionArrear}
                                        </td>
                                    </tr>
                                </table>
                            </Row>
                        </Collapse.Panel>

                        <Col
                            md={24}
                            xs={24}
                            lg={24}
                            style={{
                                marginTop: 20,
                            }}
                        >
                            <Button
                                onClick={() => {
                                    const newShowTables = [...showTables];
                                    newShowTables[id] = !newShowTables[id];
                                    setShowTables(newShowTables);
                                }}
                                className="more-button"
                            >
                                {localize('info-absence-tax-debt-more-detailed', translations)}
                            </Button>
                        </Col>

                        {showTables[id] && (
                            <Row>
                                <Col
                                    md={24}
                                    xs={24}
                                    lg={24}
                                    className="my-3 fs-6"
                                    style={{ marginTop: 20, marginBottom: 20 }}
                                >
                                    <p
                                        style={{
                                            fontWeight: 500,
                                            fontSize: 18,
                                        }}
                                    >
                                        {localize(
                                            'info-absence-tax-debt-debts-table-taxpayer',
                                            translations
                                        )}
                                    </p>
                                </Col>

                                <Table
                                    columns={thirdColumns}
                                    pagination={false}
                                    dataSource={[taxItem?.taxpayerInfo] as any[]}
                                    className="table-default"
                                    scroll={{ y: 500 }}
                                    style={{
                                        border: '1px solid rgb(214, 214, 230)',
                                        marginBottom: 20,
                                    }}
                                />

                                <Table
                                    columns={fourColumns}
                                    pagination={false}
                                    dataSource={[taxItem] as any[]}
                                    className="table-default"
                                    scroll={{ y: 500 }}
                                    style={{
                                        border: '1px solid rgb(214, 214, 230)',
                                    }}
                                />

                                {taxItem?.taxpayerInfo?.totalArrear > 0 && (
                                    <>
                                        {/* <Col
                                            md={24}
                                            xs={24}
                                            lg={24}
                                            style={{
                                                justifyContent: 'flex-end',
                                            }}
                                        >
                                            <Button
                                                className="more-button"
                                                onClick={() => {
                                                    setShowDebts((prevState) => ({
                                                        ...prevState,
                                                        [taxItem]: !prevState[taxItem],
                                                    }));
                                                }}
                                            >
                                                {localize(
                                                    'info-absence-tax-debt-more-detailed',
                                                    translations
                                                )}
                                            </Button>
                                        </Col> */}

                                        <Col
                                            md={24}
                                            xs={24}
                                            lg={24}
                                            className="my-3 fs-6"
                                            style={{ marginTop: 20, marginBottom: 20 }}
                                        >
                                            <p
                                                style={{
                                                    fontWeight: 500,
                                                    fontSize: 18,
                                                }}
                                            >
                                                {localize(
                                                    'info-absence-tax-debt-tax-debt-amount-table',
                                                    translations
                                                )}
                                            </p>
                                        </Col>

                                        <Col
                                            md={24}
                                            xs={24}
                                            lg={24}
                                            style={{ marginTop: 20, marginBottom: 20 }}
                                        >
                                            <Table
                                                columns={fiveColumns}
                                                pagination={false}
                                                dataSource={taxItem?.taxpayerInfo?.bccArrearsInfos.map(
                                                    (row) => ({
                                                        ...row,
                                                        msuCode: taxItem.charCode,
                                                    })
                                                )}
                                                className="table-default"
                                                scroll={{
                                                    x: true,
                                                }}
                                                style={{
                                                    border: '1px solid rgb(214, 214, 230)',
                                                }}
                                            />
                                        </Col>
                                    </>
                                )}
                            </Row>
                        )}
                    </div>
                );
            })}

            <Row
                gutter={15}
                className="print__btn"
            >
                <Row
                    gutter={15}
                    justify="end"
                    className="mt-3"
                >
                    <Col>
                        <PrintForm2
                            apiUrl={printUrl}
                            tokenStr={token}
                            icon={<PrintIcon />}
                            translations={translations}
                        />
                    </Col>
                </Row>
            </Row>
        </>
    );
};

export default Results;
